import React, { useEffect, useState } from 'react';
import DashBoardHolder from '../../Images/dashboardPlaceholder.svg';
import Navbar from '../NavBar/Navbar';
import MapDashboard from '../myproporties/MapDashboard';
import { useLocation, useNavigate } from 'react-router-dom';
import API_URLS from '../apiCalls/apiUrls';
import { removeDoublequotesPattern } from '../utils/regexPatterns'
import PopUPModal from '../utils/Modal'
import { useUser } from "../utils/UserContext.jsx"; // Import the custom hook
import FadeLoader from "react-spinners/FadeLoader";
const Dashboard = (props) => {
    const navigate = useNavigate();
    const [isdashboard, setDashboard] = useState(true);
    const [mapvisible, setMapvisible] = useState(false);
    const location = useLocation();
    const { userDetails } = useUser();
    const { empDetails } = useUser();
    const { loader } = useUser();
    const RegisterProperty = (e) => {
        if (empDetails?.companyEmail?.includes('@geoparking.com')) {
            navigate('/OwnerRegistrationDashboard', { state: { showOwnerRegistration: true } });
        }
        else {
            e.preventDefault();
            setDashboard(false);
            handleMapvisible(true);
        }
    }
    const handleMapvisible = (val) => {
        setMapvisible(val);
    }
    useEffect(() => {
        if (location.state?.isDashboard !== undefined) {
            setDashboard(location.state.isDashboard);
        }
    }, [location.state]);
    return (
        <div>
            {loader && (
                <div className="loader-overlay">
                    <FadeLoader />
                </div>
            )}
            <Navbar mapvisible={mapvisible} userDetails={userDetails} setMapvisible={handleMapvisible} />
            {isdashboard ? (
                <div className="container-fluid p-0">

                    <div className="dashboard">
                        <div className="rectangle" />
                        <div className="rectangle-2" />
                    </div>
                    <div className="dashboardContainer-fluid DashBoardBody">
                        <div className="illustration-auntum">
                            <img className="clip-path-group" alt="Clip path group" src={DashBoardHolder} />
                        </div>
                        <div>
                            <p className="dashboardheaders">
                                Welcome {empDetails?.firstName || userDetails?.firstName || "User"} to Your GeoParking Dashboard!
                            </p>

                            <p className="we-re-thrilled-to">
                                {PopUPModal.Dasboard_Description}
                            </p>
                        </div>
                        <div className="registerframe">
                            <button className='reg-property' onClick={RegisterProperty}>
                                {empDetails?.companyEmail?.includes('@geoparking.com') ? 'Register Owner' : 'Register Property'}
                            </button>
                        </div>
                    </div>
                </div>
            ) : (
                <MapDashboard userData={userDetails} entityId={userDetails.entityRegistrationID} defaultaddress={userDetails.enityMailingAdderess} mapVisibleChangesAlert={handleMapvisible} defaultRegion={userDetails.country} />
            )}
        </div>
    );
};

export default Dashboard;
